<template>
  <Walkthrough 
    roomName="Garage"
    roomKey="garage"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="german"
  />
</template>
<script>

export default {
  name: 'JailCell',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/garage-1920x1280.jpg",
      steps: [
        "Schaue nach rechts und inspiziere dann die Regale, wo du ein Tuch und einen Eimer finden solltest. ",
        "Schau nach links und inspiziere das Motorrad. Sie bemerken, dass es undicht ist, also sollten Sie etwas von diesem Öl einfangen, um den Generator anzutreiben. ",
        "Während Sie nach links schauen, benutzen Sie den Eimer auf dem Motorrad, um es zu füllen. ",
        "Schaue nach rechts und benutze den Eimer am Generator. Versuchen Sie dann, den Generator zu verwenden. ",
        "Ohne den Seilzug startet der Generator nicht. Verwenden Sie das Seil am Generator als provisorischen Seilzug. Der Generator sollte jetzt starten und etwas Strom in den Raum bringen. ",
        "Schaue nach vorne und benutze das Tuch am Garagentor, um die Fenster zu reinigen. Du erkennst, dass du auf HIDE stehst. Dies sollte mit der Toolbox helfen. ",
        "Schaue nach unten und inspiziere die Toolbox. ",
        "Geben Sie den Code 8 - 9 - 4 - 5 ein (H I D E). Die Toolbox sollte öffnen und Sie werden etwas Fett finden. ",
        "Schaue nach rechts, inspiziere die Regale und inspiziere den Kassettenspieler. Sie sollten etwas mehr Code hören. Dies ist der Code für den Stromschalter! ",
        "Schauen Sie nach links und inspizieren Sie den Stromschalter. ",
        "Schließen Sie die Kabel ROT, WEISS, BLAU, GRÜN an und die Stromversorgung sollte im Raum angehen.",
        "Schau nach oben und nutze das Fett am Garagentoröffner, damit es reibungslos funktioniert.",
        "Schließlich, freuen Sie sich, und benutzen Sie den Knopf, um das Garagentor zu öffnen und ESCAPE! "
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/walkthrough/de/garage.vue